module.exports = __webpack_public_path__ + "img/mk.77ae162b.svg";